module.exports = __webpack_public_path__ + "static/img/2.c5d4ef5.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/management/2.png
// module id = 4Nzw
// module chunks = 7